import { call, put } from 'redux-saga/effects'

import PopupQueue from 'common/modules/popupQueue'

import { set } from '../actions'

const setCreators = set.creators()

function* setPopupsProcessor({ popups } = {}) {
    try {
        if (!popups?.length) {
            throw new Error('popups must be an array of greater than zero')
        }

        yield put(
            yield call(
                PopupQueue.create,
                {
                    payload: {
                        items: popups,
                    },
                },
            ),
        )

        yield put(
            yield call(
                setCreators.setSuccess,
                {
                    payload: {
                        popups,
                    },
                },
            ),
        )
    } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error(error)

        yield put(
            yield call(
                setCreators.setError,
                {
                    error,
                },
            ),
        )
    }
}

export default setPopupsProcessor
